import { DateTime } from 'luxon';

const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const NAME_VALIDATION_REGEX = /^\S*$/;

export const validateEmail = (email: string) => {
  const emailValidationRegex = new RegExp(EMAIL_VALIDATION_REGEX);
  const normalizedEmail = email.trim();
  return emailValidationRegex.test(normalizedEmail) &&
    normalizedEmail.toLowerCase() !== 'cds@caregem.org';
};

export const validateCellPhone = (value: string) =>
  /^\d{10}$/.test(value.replace(/[\s()-]/g, ''));

export const validateZipCode = (value: string) =>
  /^(\d{5}|\d{9})$/.test(value.replace(/[\s-]/g, ''));

export const validateSSN = (value: string) => {
  const digits = value.replace(/[\s-]/g, '');
  if (!/^\d{9}$/.test(digits)) return false;
  const area = digits.slice(0, 3);
  return !(
    area === '000' || area === '666' || area.startsWith('9') ||
    digits.slice(3, 5) === '00' || digits.slice(5) === '0000' ||
    digits === '123456789' || /^(\d)\1{8}$/.test(digits) ||
    ['987654321', '078051120', '219099999'].includes(digits)
  );
};

export const validateDOB = (value: string | DateTime | null | undefined) => {
  if (!value) return false;
  if (DateTime.isDateTime(value)) {
    return value.isValid && value.startOf('day') < DateTime.local().startOf('day');
  }
  const input = value.trim();
  const formats = ['yyyy-MM-dd', 'MM-dd-yyyy', 'MM/dd/yyyy'];
  for (const format of formats) {
    const date = DateTime.fromFormat(input, format);
    if (date.isValid && date.toFormat(format) === input) {
      return date.startOf('day') < DateTime.local().startOf('day');
    }
  }
  return false;
};

export const validateName = (name: string) => {
  const nameValidationRegex = new RegExp(NAME_VALIDATION_REGEX);
  return nameValidationRegex.test(name);
};

export const sortByName = (unsortedArray: any) => {
  const totalCount = 'total_count';
  const sortedArray = unsortedArray[1]?.hasOwnProperty(totalCount)
    ? unsortedArray[0]?.sort(
        (
          a: { first_name: string; last_name: string },
          b: { first_name: string; last_name: string },
        ) =>
          a.last_name === b.last_name
            ? a.first_name?.localeCompare(b.first_name)
            : a.last_name?.localeCompare(b.last_name),
      )
    : unsortedArray?.sort(
        (
          a: { first_name: string; last_name: string },
          b: { first_name: string; last_name: string },
        ) =>
          a.last_name === b.last_name
            ? a.first_name?.localeCompare(b.first_name)
            : a.last_name?.localeCompare(b.last_name),
      );
  return sortedArray;
};

const getIsInvalidReason = (dateValue: DateTime) => {
  if (dateValue && dateValue?.invalidReason) {
    return true;
  }
  return false;
};

export const getIsDOBInvalid = (
  dateValue: DateTime | null | undefined,
  isRequired: boolean,
) => {
  if (isRequired) {
    if (!dateValue) {
      return true;
    }
    return getIsInvalidReason(dateValue);
  }
  if (!dateValue) {
    return false;
  }
  return getIsInvalidReason(dateValue);
};
